export default __webpack_public_path__ + "static/media/180px-Sunset-Title-PMR-light-border.389c58fa.png";